// src/utils/state.js — localStorage state management + offline queue

const STATE_KEY  = 'mylo_state_v3';
const QUEUE_KEY  = 'mylo_offline_queue';
const BACKUP_KEY = 'mylo_state_backup';

const DEFAULT_STATE = {
  profile:  {},
  tasks:    [],
  routines: [],
  habits:   [],
  workouts: [],
  events:   [],
  vinyl:    [],
  finance:  [],
  income:   [],
  budgets:  [],
  goals:    [],
  quickLists: [],
  triumphs: [],
  coachHistory: [],
  trainRoutines: [],
  memories: [],
  financeCategories: [],
  accounts:          [],
  transactions:      [],
  customWorkoutTypes: [],
  prefs:    {},
  pulseConfig: null,
  raceName: '',
  raceDate: '',
};

export function loadState() {
  try {
    const raw = localStorage.getItem(STATE_KEY);
    if (!raw) return { ...DEFAULT_STATE };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_STATE, ...parsed };
  } catch {
    // Try backup
    try {
      const backup = localStorage.getItem(BACKUP_KEY);
      if (backup) return { ...DEFAULT_STATE, ...JSON.parse(backup) };
    } catch {}
    return { ...DEFAULT_STATE };
  }
}

export function saveState(state) {
  try {
    const serialized = JSON.stringify(state);
    // Write backup before main write
    const prev = localStorage.getItem(STATE_KEY);
    if (prev) localStorage.setItem(BACKUP_KEY, prev);
    localStorage.setItem(STATE_KEY, serialized);
    return true;
  } catch (e) {
    console.warn('[state] saveState failed:', e);
    return false;
  }
}

// ── Offline queue ─────────────────────────────────────────────────────────────

export function getOfflineQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function addToOfflineQueue(op) {
  try {
    const q = getOfflineQueue();
    q.push({ ...op, ts: Date.now() });
    // Cap at 100 items to prevent unbounded growth
    const trimmed = q.slice(-100);
    localStorage.setItem(QUEUE_KEY, JSON.stringify(trimmed));
  } catch (e) {
    console.warn('[state] addToOfflineQueue failed:', e);
  }
}

export function clearOfflineQueue() {
  try {
    localStorage.removeItem(QUEUE_KEY);
  } catch {}
}

export function getQueueLength() {
  return getOfflineQueue().length;
}
